module.exports = __webpack_public_path__ + "img/flag.109cbe56.svg";